import { HomeworkLink } from './homework-link';

export class Worksheet {
    id: string;
    name: string;
    homework: null|HomeworkLink
}
